import React from "react";
import {
    CalendarOutlined,
    CarOutlined,
    CodeOutlined,
    LockOutlined,
    QuestionCircleOutlined,
    SettingOutlined,
    ShopOutlined,
    UserOutlined
} from "@ant-design/icons";

//region Components import
import App from "../Home";

// Bookings
import BookingMapContainer from "../containers/member/bookings/bookingMap/BookingMapContainer";
import BookingMapCreate from "../containers/member/bookings/bookingMap/BookingMapCreate";
import BookingManage from "../containers/staff/bookings/BookingManage";

// Locations
import LocationsView from "../containers/staff/locations/LocationsView";
import LocationManage from "../containers/staff/locations/LocationManage";

// Personal Info
import PersonalInfoTabs from "../containers/staff/accounts/PersonalInfoTabs";

// Vehicles
// import SingleCarAvailabilityViewStandalone from "../containers/member/deployments/SingleCarAvailabilityViewStandalone";
import CarManage from "../containers/member/cars/CarManage";
import CarManageStaff from "../containers/staff/cars/CarManageStaff";
import CarsView from "../containers/member/cars/CarsView";
import CarsViewStaff from "../containers/staff/cars/CarsViewStaff";
import CarEdit from "../containers/staff/cars/CarEdit";
import CarAdd from "../containers/staff/cars/CarAdd";

import MyBookings from "../containers/member/bookings/MyBookings";
import ChangeMember from "../containers/staff/memberships/ChangeMember";
import BookingGridView from "../containers/member/bookings/BookingGridView";

import AccountCreate from "../containers/staff/accounts/AccountCreate";
import AccountInfoStaff from "../containers/staff/accounts/AccountInfoStaff";
import AccountInfo from "../containers/member/accounts/AccountInfo";
import AccountPersonAdd from "../containers/staff/accounts/AccountPersonAdd";

import ContactMain from "../containers/member/help/ContactMain";

import AccessoriesView from "../containers/staff/cars/AccessoriesView";

// Business Info
import AccountBusinessInfo from "../containers/member/accounts/AccountBusinessInfo";
import AccountBusinessInfoStaff from "../containers/staff/accounts/AccountBusinessInfoStaff";

import Billing from "../containers/member/billings/Billing";
import Invoices from "../containers/member/billings/Invoices";
import BillingStaff from "../containers/staff/billings/BillingStaff";
import InvoicesStaff from "../containers/staff/billings/InvoicesStaff";

import Invoicing from "../containers/staff/admin/Invoicing";
import MassEmail from "../containers/staff/admin/MassEmail";
import Tickets from "../containers/staff/staffTickets/Tickets"
import FormLetters from "../containers/staff/formLetters/FormLetters"

import ProfileChange from "../containers/member/accounts/profiles/ProfileChange";

import Reports from "../containers/staff/reports/Reports";

import Shares from "../containers/staff/shares/Shares";

import Promotions from "../containers/staff/promotions/Promotions";

import Security from "../containers/member/security/Security";
import SecurityStaff from "../containers/staff/security/SecurityStaff";

import StaffManagement from '../containers/staff/staffManagement/StaffManagement';

import PageNotFound from "../components/PageNotFound";
//endregion
import {MODULE_BILLING, MODULE_BILLING_INVOICING} from "../lib/site";

/**
 * The Paths object contains definitions for all available paths/URLS within the app.
 * This can be used by the RoutesConfig and SidebarLinks definitions, as well as ad-hoc across the application if necessary.
 */
const Paths = {
    root: '/',

    // booking menu
    booking: '/booking/:bookingID',
    bookingCreate: '/booking/create',
    bookingMap: '/booking/map',
    myBookings: '/booking/list',
    bookingMapCreate: '/booking/map/create',

    // fleet menu
    cars: '/fleet/car/list',
    carsManage: '/fleet/car',
    carsEdit: '/fleet/car/edit',
    carsAdd: '/fleet/car/add',
    accessoriesView: '/fleet/accessory/list',
    locations: '/fleet/location/list',
    locationManage: '/fleet/location',

    // profile menu
    personalInfoTabs: '/profile/personal_info',
    sharesPersonal: '/profile/shares_personal',
    security: '/profile/security',

    //business menu
    businessInfo: '/business/business_info',
    sharesBusiness: '/business/shares_business',

    // account menu
    account: '/account/account_info',
    accountInfo: '/account/account_info',
    accountPersonAdd: '/account/add_person',
    accountNew: '/account/new_account',
    billing: '/account/billing',
    invoices: '/account/invoices',

    //admin menu
    massEmail: '/admin/mass_email',
    tickets: '/admin/tickets',
    formLetters: '/admin/form_letters',
    invoicing: '/admin/invoicing',
    reports: '/admin/reports',
    promotions: '/admin/promotions',
    staffManagement: '/admin/staff_management',

    // contact menu
    contact: '/contact',

    // miscellaneous
    changeMember: '/member_change',
    changeProfile: '/profile_change',

    // 404 error
    pageNotFound: '/404',
};


/**
 * This is the main configuration array for available routes.
 * Adding a route here will make it available via URL.
 * Setting staffOnly=true here will make the entire route blocked to non-staff users.
 * NOTE:  This does not affect sidebar menu links - see SidebarLinks array below.
 * @type {*[]}
 */
const RoutesConfig = [
    {
        path: Paths.root,
        component: App
    },
    //region Bookings
    {
        path: Paths.bookingCreate,
        component: BookingGridView,
        membershipRequired: true,
    },
    {
        path: Paths.booking,
        component: BookingManage,
        membershipRequired: true,
    },
    {
        path: Paths.myBookings,
        component: MyBookings,
        membershipRequired: true,
    },
    {
        path: Paths.bookingMapCreate,
        component: BookingMapCreate,
        membershipRequired: true,
    },
    // Comment out so prod clients are not confused from incomplete feature.
    // {
    //     path: Paths.bookingMap,
    //     component: BookingMapContainer,
    //     membershipRequired: true,
    // },
    //endregion
    //region Cars
    {
        path: Paths.cars,
        hasStaff: true,
        staffComponent: CarsViewStaff,
        component: CarsView,
        membershipRequired: true,
    },
    {
        path: Paths.carsManage,
        component: CarManage,
        staffComponent: CarManageStaff,
        hasStaff: true,
        membershipRequired: true,
    },
    {
        path: Paths.carsEdit,
        component: CarEdit,
        staffOnly: true,
    },
    {
        path: Paths.carsAdd,
        component: CarAdd,
        staffOnly: true,
    },
    //endregion
    //region Accessories
    {
        path: Paths.accessoriesView,
        component: AccessoriesView,
        staffOnly: true,
    },
    //endregion
    //region Locations
    {
        path: Paths.locationManage,
        component: LocationManage,
        membershipRequired: true,
    },
    {
        path: Paths.locations,
        component: LocationsView,
        staffOnly: true,
    },
    //endregion
    //region Account
    {
        path: Paths.personalInfoTabs,
        component: PersonalInfoTabs,
    },
    {
        path: Paths.businessInfo,
        component: AccountBusinessInfo,
        staffComponent: AccountBusinessInfoStaff,
        hasStaff: true,
        businessRoute: true,
    },
    {
        path: Paths.accountPersonAdd,
        component: AccountPersonAdd,
        staffOnly: true,
    },
    // {
    //     path: Paths.email,
    //     component: EmailManage,
    // },
    {
        path: Paths.accountInfo,
        component: AccountInfo,
        staffComponent: AccountInfoStaff,
        hasStaff: true,
        membershipRequired: true,
    },
    {
        path: Paths.changeMember,
        component: ChangeMember,
        staffOnly: true,
    },
    {
        path: Paths.accountNew,
        component: AccountCreate,
        staffOnly: true,
    },
    {
        path: Paths.changeProfile,
        component: ProfileChange,
    },
    {
        path: Paths.sharesPersonal,
        component: Shares,
        staffOnly: true,
    },
    {
        path: Paths.sharesBusiness,
        component: Shares,
        staffOnly: true,
        businessRoute: true,
    },
    //endregion
    //region Billing
    {
        path: Paths.billing,
        component: Billing,
        staffComponent: BillingStaff,
        hasStaff: true,
        module: MODULE_BILLING,
        membershipRequired: true,
    },
    {
        path: Paths.invoices,
        hasStaff: true,
        component: Invoices,
        staffComponent: InvoicesStaff,
        module: MODULE_BILLING_INVOICING,
        membershipRequired: true,
    },
    //endregion
    //region Admin
    {
        path: Paths.massEmail,
        component: MassEmail,
        staffOnly: true
    },
    {
        path: Paths.tickets,
        component: Tickets,
        staffOnly: true
    },
    {
        path: Paths.formLetters,
        component: FormLetters,
        staffOnly: true
    },
    {
        path: Paths.invoicing,
        component: Invoicing,
        module: MODULE_BILLING_INVOICING,
        staffOnly: true,
    },
    {
        path: Paths.reports,
        component: Reports,
        staffOnly: true
    },
    {
        path: Paths.promotions,
        component: Promotions,
        staffOnly: true
    },
    {
        path: Paths.staffManagement,
        component: StaffManagement,
        staffOnly: true
    },
    //endregion
    //region Security
    {
        path: Paths.security,
        component: Security,
        staffComponent: SecurityStaff,
        hasStaff: true,
    },
    //endregion
    {
        path: Paths.contact,
        component: ContactMain,
    },
    // PageNotFound component must be LAST - it's the default fallback if a route can't be found in the above
    // Do not specify a path here. It will only function as the fallback if there is no path.
    {
        component: PageNotFound,
        path: '*',
    }
];

/**
 * This is the main configuration array for sidebar links.
 * Adding a route here makes it available in the sidebar navigation.
 * Links are loaded and displayed in the sidebar in the same order that they are typed here.
 * Setting staffOnly=true here will hide the link from non-staff users. It WILL NOT block the route - see RoutesConfig to do that.
 * NOTE: A relevant route must first be added to the RoutesConfig array above.
 * @type {*[]}
 */
const SidebarLinks = [
    {
        label: 'Bookings',
        key: 'booking',
        icon: <CalendarOutlined/>,
        membershipRequired: true,
        children: [
            {
                label: 'My Bookings',
                key: 'list',
                path: Paths.myBookings,
            },
            {
                label: 'Create Booking',
                key: 'create',
                path: Paths.bookingCreate,
            },
            // Comment out so prod clients are not confused from incomplete feature.
            // {
            //     label: 'Booking Map',
            //     key: 'map',
            //     path: Paths.bookingMap,
            // },
        ]
    },
    {
        label: 'Fleet',
        key: 'fleet',
        icon: <CarOutlined/>,
        membershipRequired: true,
        children: [
            {
                label: 'Vehicles',
                key: 'car',
                path: Paths.cars,
            },
            {
                label: 'Accessories',
                key: 'accessory',
                path: Paths.accessoriesView,
                staffOnly: true,
            },
            {
                label: 'Locations',
                key: 'location',
                path: Paths.locations,
                staffOnly: true,
            },
        ]
    },
    {
        label: 'Profile',
        key: 'profile',
        icon: <UserOutlined/>,
        children: [
            {
                label: 'Personal Info',
                key: 'personal_info',
                path: Paths.personalInfoTabs,
            },
            {
                label: 'Security',
                key: 'security',
                path: Paths.security,
            },
            {
                label: 'Personal Shares',
                key: 'shares_personal',
                path: Paths.sharesPersonal,
                staffOnly: true,
            }
        ]
    },
    {
        label: 'Business',
        key: 'business',
        icon: <ShopOutlined/>,
        businessComponent: true,
        children: [
            {
                label: 'Company Info',
                key: 'business_info',
                path: Paths.businessInfo,
            },
            {
                label: 'Business Shares',
                key: 'shares_business',
                path: Paths.sharesBusiness,
                staffOnly: true,
            }
        ]
    },
    {
        label: 'Account',
        key: 'account',
        icon: <SettingOutlined/>,
        membershipRequired: true,
        children: [
            {
                label: 'Account Info',
                key: 'account_info',
                path: Paths.accountInfo,
                membershipRequired: true,
            },
            {
                label: 'Billing',
                key: 'billing',
                path: Paths.billing,
                module: MODULE_BILLING,
                membershipRequired: true,
            },
            {
                label: 'Invoices',
                key: 'invoices',
                path: Paths.invoices,
                module: MODULE_BILLING_INVOICING,
                membershipRequired: true,
            },
            {
                label: 'Create New Account',
                key: 'new_account',
                path: Paths.accountNew,
                staffOnly: true,
            },
        ]
    },
    {
        label: 'Admin',
        key: 'admin',
        icon: <LockOutlined/>,
        staffOnly: true,
        children: [
            {
                label: 'Invoicing',
                key: 'invoicing',
                path: Paths.invoicing,
                module: MODULE_BILLING_INVOICING,
            },
            {
                label: 'Mass Email',
                key: 'mass_email',
                path: Paths.massEmail,
            },
            {
                label: 'Tickets',
                key: 'tickets',
                path: Paths.tickets,
            },
            {
                label: 'Form Letters',
                key: 'form_letters',
                path: Paths.formLetters,
            },
            {
                label: 'Reports',
                key: 'reports',
                path: Paths.reports,
            },
            {
                label: 'Promotions',
                key: 'promotions',
                path: Paths.promotions,
            },
            {
                label: 'Staff Management',
                key: 'staff_management',
                path: Paths.staffManagement,
            }
        ]
    },
    {
        label: 'Contact',
        key: 'contact',
        path: Paths.contact,
        icon: <QuestionCircleOutlined/>,
    },

];

const TestPaths = {
    carsSingle: '/cars/single',
    bookingMap: '/booking/map',
    bookingGrid: '/booking/grid',
};

const TestRoutes = [
    // Commented out as it causes issues for typechecking.
    // {
    //     path: TestPaths.carsSingle,
    //     props: {
    //         deployment_id: 5
    //     },
    //     component: SingleCarAvailabilityViewStandalone
    // },
    {
        path: TestPaths.bookingMap,
        component: BookingMapContainer,
    },
];

const TestSidebarLinks = [
    {
        label: 'Test Pages',
        icon: <CodeOutlined/>,
        children: [
            // {
            //     label: 'Single Car Availability',
            //     key: 'car_single_test',
            //     path: TestPaths.carsSingle,
            // },
            {
                label: 'Booking Map',
                key: 'test_map',
                path: TestPaths.bookingMap,
            },
        ]
    },
];

export {
    RoutesConfig, SidebarLinks, TestRoutes, TestSidebarLinks, Paths
};
